import { lazy } from 'react'

export const Screen =  lazy(() => import('./Screen'))
export const ScreenHeader =  lazy(() => import('./ScreenHeader'))
export const ScreenHeaderWithInbox =  lazy(() => import('./ScreenHeaderWithInbox'))
export const NavigationMenu =  lazy(() => import('./NavigationMenu'))
